export default __webpack_public_path__ + "static/media/showcase-drone.170e6437.svg";